import * as React from 'react';
import { SVGProps } from 'react';

export const TableIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.5 4.75H3.5C3.33424 4.75 3.17527 4.81585 3.05806 4.93306C2.94085 5.05027 2.875 5.20924 2.875 5.375V16C2.875 16.3315 3.0067 16.6495 3.24112 16.8839C3.47554 17.1183 3.79348 17.25 4.125 17.25H17.875C18.2065 17.25 18.5245 17.1183 18.7589 16.8839C18.9933 16.6495 19.125 16.3315 19.125 16V5.375C19.125 5.20924 19.0592 5.05027 18.9419 4.93306C18.8247 4.81585 18.6658 4.75 18.5 4.75ZM4.125 9.75H7.25V12.25H4.125V9.75ZM8.5 9.75H17.875V12.25H8.5V9.75ZM17.875 6V8.5H4.125V6H17.875ZM4.125 13.5H7.25V16H4.125V13.5ZM17.875 16H8.5V13.5H17.875V16Z"
      fill="#071114"
    />
  </svg>
);
export default TableIcon;
